import angular from 'angular';
import uiRouter from 'angular-ui-router';
import analyticsComponent from './analytics-traffic.component';

let analyticsModule = angular.module('app.containers.analytics-traffic', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('analyticsTraffic', {
      url: '/analytics-traffic',
      template: '<analytics-traffic></analytics-traffic>'
    });
})

.component('analyticsTraffic', analyticsComponent);

export default analyticsModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics-traffic/analytics-traffic.js
 **/